import { render, staticRenderFns } from "./plans-virtual.vue?vue&type=template&id=3ab7d19e&scoped=true&"
import script from "./plans-virtual.vue?vue&type=script&lang=js&"
export * from "./plans-virtual.vue?vue&type=script&lang=js&"
import style0 from "./plans-virtual.vue?vue&type=style&index=0&id=3ab7d19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7d19e",
  null
  
)

export default component.exports